<template>
  <div class="Imprint">
    <!--   印记头部-->
    <div class="imprint-header">
      <div class="header">
        <i></i>
        <span class="scan-title">印迹</span>
      </div>
    </div>
    <!--    内容区域-->
    <router-view></router-view>
    <!--    底部导航栏-->
    <div class="imprint-bottom" v-if="vueAppTypeName===''">
      <Tab :navbarList="navbarList"></Tab>
    </div>
    <Overlay></Overlay>
  </div>
</template>

<script>
import Tab from '../../components/Tab/Tab'
import { mapActions } from 'vuex'
import api from '../../utils/api'
import { aGet, aPost } from '../../utils/request'
export default {
  data() {
    return {
      resourceId: 0,
      vueAppTypeName: process.env.VUE_APP_TYPE_NAME || '',
      //底部导航
      navbarList: [

        //{ name: '我买进的', path: '/Imprint' },
        //{ name: '我卖出的', path: '/GiveUp' },
        { name: '我买进的', path: '/imprint/bought' },
        { name: '我卖出的', path: '/imprint/sold' },
        { name: '我推广的', path: '/agent/order' },
        { name: '我的关注', path: '/FocusOn' },
       // { name: '收到广告', path: '/getAdver' },
       // { name: '我的广告', path: '/DownEdit' }
      ],

      //权限 状态
      powerStatus: false,

    }
  },
  components: {
    Tab: Tab,
    Overlay: () => import('../../components/Overlay/Overlay')
  },
  computed: {
    bmTab() {
      return this.$store.state.bmTab
    },
  },
  methods: {
    ...mapActions(['setStoreId']),

    //权限检测
    async checkPermissions() {
      let parma = {
        storeId: localStorage.getItem('storeId')
      }
      aGet(api.getMyStorePermissionsList, parma).then((res) => {
        console.log('我的店铺权限:', res.data)
        this.permissionsList = res.data.data
        console.log("permissionsList:",this.permissionsList)
        let obj = this.permissionsList.filter((item) => item.powerName == '订单列表')
        console.log("jumpDetail obj:",obj.length)

        this.powerStatus = obj.length>0?true:false;
        console.log("jumpDetail powerStatus:",this.powerStatus)
        setTimeout(() => {
          if (this.powerStatus != undefined) {
            if (this.powerStatus == false) {
              this.$toast('您暂无此权限,请先购买权限配置！')
              this.$router.push({
                path: '/buyservice'
              })
            }
          }
        }, 300)
      })
    },

  },
  created() {
    if (this.vueAppTypeName==='ZUDIAN') {
      this.navbarList =  [
        { name: '我的关注', path: '/FocusOn' },
      ]
    }
    this.resourceId = this.$route.query.resourceId || 0;
    console.log("resourceId==================", this.resourceId);
    localStorage.setItem('resourceId', this.resourceId); // 可选，存储到 localStorage
    this.$store.commit('setResourceId', this.resourceId); // 使用 Vuex 传递


    // console.log(this.$route)
    this.setStoreId(JSON.parse(localStorage.getItem('storeId')))
    this.$store.state.bmTab = 4

    //检测权限
    this.checkPermissions()
  },

  mounted() {
    // this.aboutValuda();
  },
  updated() {}
}
</script>

<style scoped lang="scss">
@import '../../assets/mixin';
.Imprint {
  width: 100%;
  background: $bgcolor;
  //头部
  .imprint-header {
    width: 100%;
    height: 86px;
    //padding: 30px 0 16px 32px;
    background-color: #ffffff;
    position: fixed;
    top: 54px;
    left: 0;
    .header {
      width: 100%;
      height: 86px;
      padding: 30px 0 0 32px;
      i {
        display: inline-block;
        width: 40px;
        height: 40px;
        background: url('../../assets/img/baby/talk-baby.png') center center no-repeat;
        background-size: contain;
        vertical-align: -6px;
        margin-right: 16px;
      }
      span {
        display: inline-block;
        font-size: 34px;
        color: #dc6a2b;
        line-height: 34px;
        font-weight: bold;
      }
    }
    /* //顶部Tab
      .tabbar{
        width: 100%;
        background-color: #FFFFFF;
      }*/
  }
  // 底部导航栏
  .imprint-bottom {
    width: 100%;
    height: 96px;
    background-color: #ffffff;
    position: fixed;
    bottom: 100px;
    left: 0;
    border-radius: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Imprint/Imprint.vue